import { render, staticRenderFns } from "./AuctionViewType.vue?vue&type=template&id=0712698e&scoped=true&"
import script from "./AuctionViewType.vue?vue&type=script&lang=js&"
export * from "./AuctionViewType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712698e",
  null
  
)

export default component.exports